// postal code can be from any country hence removed regex
export const isValidPostalCode = (postalCode: string) => {
  // const regex = /^\d{5}$/g;
  // return regex.test(postalCode);
  return postalCode.length > 0;
};
